const isDebugMode = (): boolean => window.location.search.indexOf("debug") >= 0

export default isDebugMode
